import React from "react";

interface Props {
  condition: boolean;
  then: React.ReactNode | (() => React.ReactNode);
  else?: React.ReactNode | (() => React.ReactNode);
}

const If: React.FC<Props> = (props) => {
  if (props.condition) return render(props.then);
  if (props.else) return render(props.else);
  return null;
};

function render(node: React.ReactNode | (() => React.ReactNode)) {
  if (typeof node === "function") return <>{node()}</>;

  return <>{node}</>;
}

export default If;
